<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12"></div>
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- ngx-datatable-filter -->
            <fieldset class="form-group">
              <div class="row align-items-end mt-0 pagination-body">

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-2">
                  <div class="btn-group enrollment-list-btn-info" role="group">
                    <button class="btn enrollment-list-buttons cursor-pointer" type="button"
                      *ngFor="let status of statusList"
                      [ngClass]="{'btn-primary':activeTab==status?.name,'btn-outline-primary':activeTab!=status?.name}"
                      (click)="activeEmployeeTab(status?.name)">{{status.displayname}}</button>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                  <div class="row-flex">
                    <div class="col-flex-2">
                      <div class="dropdown btn-group dropup mr-1 mb-1" ngbDropdown>
                        <button type="button" class="btn btn-outline-primary btn2">{{employee_type}}</button>
                        <button type="button" class="btn btn-outline-primary dropdown-toggle" ngbDropdownToggle
                          aria-haspopup="true" aria-expanded="false">
                          <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <div ngbDropdownMenu class="dropdown-menu" role="menu">
                          <button class="dropdown-item" *ngFor="let item of emp_typeList"
                            (click)="getTypeId(item?._id,item?.displayname)">{{item?.displayname}}</button>
                        </div>
                      </div>
                      </div>
                    <div class="col-flex-2 mb-1 position-relative" placement="top"
                      ngbTooltip="search by  name,email,phone,pan,account number,empcode">
                      <input id="ngx-filter-ref"
                        class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                        type="text" placeholder="Search" #name [(ngModel)]="searchVal"
                        (keydown.enter)="getEmployeeSearch(searchVal)" />
                      <button class="btn search-btn glow position-absolute" (click)="getEmployeeSearch(searchVal)">
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1">
                      <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">
                        Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1"
                      *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                      <button type="button" class="btn btn-primary btn-block users-list-clear glow mb-0"
                        routerLink="/employees/add" placement="top" ngbTooltip="Add New">
                        +
                      </button>
                    </div>

                  </div>
                </div>
                <div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="row-flex">
                      <div class="col-flex-2">
                        <label for="file-upload" class="btn btn-primary btn-block users-list-clear glow mb-0">Upload file</label>
                        <input type="file" accept=".csv" id="file-upload" (change)="onSelectFile($event)"/>
                      </div>
                      <div class="col-flex-2" *ngIf="guideline_data">
                        <button class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Employee Guideline</button>
                      </div>

                    </div>
                    
                  </div>
                </div>
                <div class=" col-12 col-sm-12 col-md-12 col-lg-12 pagination-body header-body mb-2">
                  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                    [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                    [count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)">
                    <ngx-datatable-footer>
                      <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize">
                        <div class="datatable-footer-inner">
                          <div class="total-count">
                            <span>Total : {{page.totalPages}}
                              <span> &nbsp;<span *ngIf="activeTab !== 'exemployee'">Total Salary :
                                  {{total_salary}}</span>
                              </span>
                            </span>
                          </div>
                        </div>
                      </ng-template>
                    </ngx-datatable-footer>

                  </ngx-datatable>
                </div>
              </div>
              <div>
                <div class="col-flex-2">
                  <button data-toggle="collapse" data-target="#demo" class="btn btn-outline-primary" (click)="toggleCollapse()" [attr.aria-expanded]="isCollapsed ? 'false' : 'true'">{{ isCollapsed ? 'Collapse' : 'Expand' }}</button>
                </div>
              </div>
            </fieldset>
            <div >
              <div *ngFor="let list of rows; let i=index">
                <div class="main_heading cursor-pointer" (click)="collapse.toggle()" [attr.aria-expanded]="empTypeView[i]"
                  aria-controls="collapseExample">
                  <h5 [ngClass]="{'bg-light-warning  ': list?.employeetype?.displayname ==='Engineering',
                                  'bg-light-success ': list?.employeetype?.displayname ==='Managment',
                                  'bg-light-danger  ': list?.employeetype?.displayname ==='Sales',
                                  'bg-light-info ': list?.employeetype?.displayname ==='Operation',
                                  'bg-light-primary ': list?.employeetype?.displayname ==='Finance',
                                  'bg-light-info ': list?.employeetype?.displayname ==='HR',
                                  'bg-light-danger ': list?.employeetype?.displayname ==='Training Moderator' || list?.employeetype?.displayname ==='Teacher'}">
  
                    {{list?.employeetype?.displayname }} ({{list?.total}})</h5>
                </div>
                <ngx-datatable id="demo" #collapse="ngbCollapse" [(ngbCollapse)]="!empTypeView[i]" class="bootstrap core-bootstrap"
                  [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
                  [limit]="limitRef" [rows]="list?.employee" [scrollbarH]="true"
                  [columns]="columns">
                  <ngx-datatable-column name="Name" prop="name" [width]="120">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                      <div class="d-flex align-items-center">
                        <div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
                          <div class="avatar-content">
                            {{ row?.user?.name | shortName }}
                          </div>
                        </div>
                        <!-- --------- card ------------------------------------ -->
                        <div class="card-overlay-on-hover">
                          <div class="card">
                            <div class="card-content">
                              <div class="card-img">
                                <div *ngIf="!row.image" class="avatarImg mr-1 ml-0 bg-primary">
                                  <div class="avatar-contentImg">{{ row?.user?.name | shortName }}</div>
                                </div>
                              </div>
                              <div class="card-body p-0">
                                <h4>{{row?.user?.name }}</h4>
                                <p>{{row?.designation}}</p>
                                <div class="d-flex flex-wrap">
                                  <p *ngFor="let skill of row?.skills; last as isLast">
                                    <span>{{skill?.displayname}}</span>
                                    <span *ngIf="row?.skills.length >1 && !isLast"> , </span>
                                  </p>
                                </div>
                                <div class="d-flex flex-wrap">
                                  <p *ngFor="let item of row?.report_to; last as isLast">
                                    <span class="bg-light-primary">{{item?.name}}</span>
                                    <span *ngIf="row?.skills?.length >1 && !isLast"> , </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- ---------------------------------------------------------- -->
                        <div class="cell-line-height cursor-pointer" [routerLink]="['/employees/view', row?.user?._id]">
                          <p class="font-medium-1 line-height-1 mb-0">
                            {{ row?.user?.name }}
                          </p>
                        </div>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Email" prop="email" [width]="140">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                      {{row?.user?.email}}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Employee Type" prop="employeetype" [width]="60">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <!-- <p *ngFor="let empType of row?.employeetype"> -->
  
                        <span *ngIf="list?.employeetype?.displayname === 'Managment'"
                          (click)="openModal(myModal,row?.user?._id,list?.employeetype)"
                          [ngClass]="{'bg-light-success badge badge-pill cursor-pointer':list?.employeetype?.displayname === 'Managment'}">
                          {{list?.employeetype?.displayname}}
                        </span>
                        <span *ngIf="list?.employeetype?.displayname === 'Engineering'"
                          (click)="openModal(myModal,row?.user?._id,list?.employeetype)"
                          [ngClass]="{'bg-light-warning badge badge-pill cursor-pointer':list?.employeetype?.displayname === 'Engineering'}">
                          {{list?.employeetype?.displayname}}
                        </span>
                        <span *ngIf="list?.employeetype?.displayname === 'Sales'"
                          (click)="openModal(myModal,row?.user?._id,list?.employeetype)"
                          [ngClass]="{'bg-light-danger badge badge-pill cursor-pointer':list?.employeetype?.displayname === 'Sales'}">
                          {{list?.employeetype?.displayname}}
                        </span>
                        <span *ngIf="list?.employeetype?.displayname === 'Operation'"
                          (click)="openModal(myModal,row?.user?._id,list?.employeetype)"
                          [ngClass]="{'bg-light-info badge badge-pill cursor-pointer':list?.employeetype?.displayname === 'Operation'}">
                          {{list?.employeetype?.displayname}}
                        </span>
                        <span *ngIf="list?.employeetype?.displayname === 'Finance'"
                          (click)="openModal(myModal,row?.user?._id,list?.employeetype)"
                          [ngClass]="{'bg-light-primary badge badge-pill cursor-pointer':list?.employeetype?.displayname === 'Finance'}">
                          {{list?.employeetype?.displayname}}
                        </span>
                        <span *ngIf="list?.employeetype?.displayname === 'HR'"
                          (click)="openModal(myModal,row?.user?._id,list?.employeetype)"
                          [ngClass]="{'bg-light-danger badge badge-pill cursor-pointer':list?.employeetype?.displayname === 'HR'}">
                          {{list?.employeetype?.displayname}}
                        </span>
                        <span *ngIf="list?.employeetype?.displayname === 'Training Moderator' || list?.employeetype?.displayname === 'Teacher'"
                          (click)="openModal(myModal,row?.user?._id,list?.employeetype)"
                          [ngClass]="{'bg-light-danger badge badge-pill cursor-pointer':list?.employeetype?.displayname === 'Training Moderator' || list?.employeetype?.displayname === 'Teacher' }">
                          {{list?.employeetype?.displayname}}
                        </span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Phone" prop="phone" [width]="40">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                      {{row?.user?.phone}}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column *ngIf="activeTab !=='exemployee'" name="Salary" prop="salary"
                    [width]="30"></ngx-datatable-column>
                  <ngx-datatable-column name="Status" prop="status" [width]="80">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <p [matMenuTriggerFor]="emp_status">
                        <span *ngIf="row?.status[0]?.displayname === 'Full Time'"
                          [ngClass]="{'bg-light-success badge badge-pill':row?.status[0]?.displayname === 'Full Time'}">
                          {{row?.status[0]?.displayname}}
                        </span>
                        <span *ngIf="row?.status[0]?.displayname === 'Part Time'"
                          [ngClass]="{'bg-light-warning badge badge-pill':row?.status[0]?.displayname === 'Part Time'}">
                          {{row?.status[0]?.displayname}}
                        </span>
                        <span *ngIf="row?.status[0]?.displayname === 'Ex-Employee'"
                          [ngClass]="{'bg-light-danger badge badge-pill':row?.status[0]?.displayname === 'Ex-Employee'}">
                          {{row?.status[0]?.displayname}}
                        </span>
                      </p>
                      <mat-menu #emp_status="matMenu">
  
                        <div>
                          <div *ngFor="let status of statusList">
                            <button mat-menu-item *ngIf="status?.name !== row?.status[0]?.name"
                              (click)="updateEmpRole(row.user?._id,status._id)">
                              <span>
                                <span [ngClass]="{'bg-light-success badge badge-pill':status.displayname === 'Full Time'}"
                                  placement="top" *ngIf="status.displayname === 'Full Time'">{{status.displayname}}</span>
                                <span [ngClass]="{'bg-light-warning badge badge-pill':status.displayname === 'Part Time'}"
                                  placement="top" *ngIf="status.displayname === 'Part Time'">{{status.displayname}}</span>
                                <span [ngClass]="{'bg-light-danger badge badge-pill':status.displayname === 'Ex-Employee'}"
                                  placement="top"
                                  *ngIf="status.displayname === 'Ex-Employee'">{{status.displayname}}</span>
                              </span>
                            </button>
                          </div>
                        </div>
                      </mat-menu>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Activated?" [width]="40" prop="is_deactivated">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <div class="custom-switch custom-control-inline mb-1 mb-xl-0">
                        <mat-slide-toggle color="primary" [checked]="row?.user?.is_activated"
                          (change)="activateStudent(row)"></mat-slide-toggle>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Actions" [width]="60"
                    *ngIf=" user_role.roles ==='admin' || user_role.roles ==='employee' || user_role.roles ==='extractor'">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <i class="ft-edit text-primary cursor-pointer  mx-1"
                        [routerLink]="['/employees/edit',row?.user?._id]"></i>
                      <!-- <i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger"
                          (click)="Delete(row._id)"></i> -->
                      <i class="ft-copy text-primary cursor-pointer mx-1" placement="top"
                        ngbTooltip="Copy Default Password"
                        (click)="copyToClipboard(row?.user?.name,row?.user?.phone)"></i>
                      <i *ngIf="user_role.roles ==='admin'" class="icon-key text-primary cursor-pointer  mx-1" placement="top"
                        ngbTooltip="set default password"
                        (click)="setDefaultPassword(row?.user?._id, row?.user?.name)"></i>
                        <i *ngIf="row?.user?.is_refral === false ||  !row?.user?.is_refral" class="ft-plus-circle text-primary cursor-pointer  mx-1"  placement="bottom" ngbTooltip="Add to Referral"  (click)="openModalForReferral(myModalContent,row?.user?._id,row?.user?.name)"></i>
                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>
              </div>
            </div>
          
            <!-- ngx-datatable-filter -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/ Filter Datatables -->
<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>

<!--------- -->

<div>
  <ng-template #myModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Employee Type Update</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <ng-select [items]="emp_typeList" bindLabel="displayname" bindValue="_id" placeholder="Select Type"
        [(ngModel)]="selected_type" [ngModelOptions]="{ standalone: true }"
        (change)="getTypeId($event)" [appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true">
      </ng-select>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="submit()">Submit</button>
    </div>
  </ng-template>
</div>

<!------------- Referral Popup --------------------------------------->
<div>
	<ng-template #myModalContent>
	  <div class="modal-header">
		<h4 class="modal-title">{{row_name}}'s Referral</h4>
		<button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
		  <span aria-hidden="true">&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
      <fieldset class="form-group" >
				<label>Report To</label>
				<ng-select
				[items]="emp_list"
				bindLabel="name"
				bindValue="user._id"
				[closeOnSelect]="false"
				placeholder="Select"
				[(ngModel)]="referral_model.report_to"
				[ngModelOptions]="{ standalone: true }"
				(change)="getEmpId($event)"
			  ></ng-select>
			  </fieldset>
			  <fieldset class="form-group">
          <label>Notes</label>
          <textarea
          [(ngModel)]="referral_model.notes"
            id="hidden-label-form-6"
            rows="3"
            class="form-control"
            name="notes"
            placeholder="Enter notes"
          ></textarea>
        </fieldset>
        <fieldset class="form-group">
          <label>Admin Notes</label>
          <textarea
          [(ngModel)]="referral_model.admin_notes"
            id="hidden-label-form-6"
            rows="3"
            class="form-control"
            name="admin_notes"
            placeholder="Enter admin notes"
          ></textarea>
        </fieldset>
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
		<button type="button" class="btn btn-primary" (click)="addReferral()">Submit</button>
	  </div>
	</ng-template>
</div>